import { request } from './request'

// 获取任务列表
export interface TaskListProps {
  //  安全域
  areaName?: string[]
  createTimeEnd?: string
  createTimeStart?: string
  //  任务分组
  groupId?: string
  //  每页几条
  limit?: number
  //  第几页
  page?: number
  //  任务名称/客户端名称
  search?: string
  //  任务状态
  //  TaskResultStatusWaiting: 等待中
  //  TaskResultStatusProcessing: 进行中
  //  TaskResultStatusFinished: 已完成
  //  TaskResultStatusInterrupted: 已中断
  //  TaskResultStatusStopping: 停止中
  taskStatus?: string[]
  //  验证类型
  //  VerificationTypeOnline: 在线验证
  //  VerificationTypeOffline: 离线验证
  verificationType?: string
  [property: string]: any
}
// 获取任务列表
export interface GetTaskList {
  task_id?: string
  search?: string
  create_time_start?: string
  create_time_end?: string
  risk_level?: number
  task_status?: number
  area_name?: string
  limit: number
  page: number
}
export const getTaskList = (data: GetTaskList) =>
  request('/portal/verify/waf/results/list', {
    params: {
      ...data,
    },
  })
// 获取任务列表安全域下拉列表
export const getArea = () => request('/portal/verify/waf/task/area_of_task_result')
// 获取任务列表站点下拉
export const getSiteDropdown = () => request('/portal/verify/waf/results/getSite')
// 获取计划任务安全域下拉列表
export const getAreaPlan = () => request('/portal/verify/waf/job/jobBizAreaList')
// 获取列表数量详情
export interface GetWafDetail {
  id: string
}
export const getWafDetail = (data: GetWafDetail) =>
  request('/portal/verify/waf/results/detail/std', {
    params: {
      ...data,
    },
  })
// 获取危险等级图标
export interface GetWafChart {
  id: string
}
export const getWafChart = (data: GetWafChart) =>
  request('/portal/verify/waf/results/detail/chart', {
    params: {
      ...data,
    },
  })
// 获取模板列表
export interface GetListDetails {
  id: number | string
  name?: any
  // limit: number
  // page: number
}
export const getListDetails = (data: GetListDetails) =>
  request('/portal/verify/waf/results/detail/template/list', {
    params: {
      ...data,
    },
  })
// 获取子模板列表
export interface GetListDetailsElement {
  result_id: string | undefined
  name?: string
  intercept_status?: number
  risk_level?: number[]
  attack_type?: number[]
  template_id?: number[]
  enctype?: number
  component?: string
  attck_name_list?: string[]
  page: number
  limit: number
  tag_ids?: string[]
}
export const getListDetailsElement = (data: GetListDetailsElement) =>
  request('/portal/verify/waf/results/detail/payload/list', {
    method: 'post',
    data,
  })
// 获取下拉列表
export interface GetGroupOption {
  template_id: string
  task_result_id: string
}
export const getGroupOption = (data: GetGroupOption) =>
  request('/portal/verify/waf/results/detail/payload/groupOption', {
    params: {
      ...data,
    },
  })
// 获取子模板列表详情右侧
export interface GetPayload {
  result_id: string
  payload_id: string
}
export const getPayload = (data: GetPayload) =>
  request('/portal/verify/waf/results/detail/payload', {
    params: {
      ...data,
    },
  })
//  删除列表
export interface DeleteList {
  ids: string[]
}
export const deleteList = (data: DeleteList) =>
  request('/portal/verify/waf/results', {
    method: 'delete',
    data,
  })
export interface GenerateReport {
  user_id?: string
  result_id: string
  report_name?: string
  name?: string
}
export const generateReport = (data: GenerateReport) =>
  request('/portal/verify/waf/results/report', {
    method: 'post',
    data,
  })

export const generateReportExcel = data =>
  request('/portal/verify/waf/results/detail/payload/list/export', {
    method: 'post',
    data,
  })

export const getAttckList = (data: GetPayload) =>
  request('/portal/verify/waf/results/detail/payload/list/attck', {
    params: {
      ...data,
    },
  })

// 任务复测
export const reTestTask = data =>
  request('/portal/verify/waf/task/taskReExec', { method: 'post', data })

//停止任务
export const stopTask = data =>
  request('/portal/verify/waf/task/stopTask', {
    method: 'post',
    data,
  })

// 获取分组列表 (筛选)
export const getGroupList = data =>
  request('/portal/v1/waf/tasks/filter/group_name', { params: data })

// 获取任务详情用例状态列表
export const getTaskDetailUseCaseStatus = data =>
  request(`/portal/v1/waf/task_results/${data.resultId}/case`)

// 任务结果 根据用例状态统计用例数
export const getTaskDetailUseCaseCount = data =>
  request(`/portal/v1/waf/task_results/${data.resultId}/case/count`, { params: data })

// 获取主任务详情
export const getTaskDrawerDetail = data => request(`/portal/v1/waf/tasks/${data.taskId}`)

// 主任务列表
export const getTaskListMain = data => request(`/portal/v1/waf/tasks`, { params: data })

// 子任务列表
export const getTaskListSub = (id: string, data: TaskListProps) =>
  request(`/portal/v1/waf/tasks/${id}/results`, { params: data })

// 删除主任务
export const deleteMainTask = data => request(`/portal/v1/waf/tasks`, { method: 'post', data })

// 获取任务基础信息
export const getTaskBaseInfo = (id: string) => request(`/portal/v1/waf/tasks/base/${id}`)

// 2.0.1
// 关联模板列表
export const getTaskDetailTemplateList = data =>
  request(`/portal/v1/waf/tasks/${data.taskId}/templateList`, { params: data })

// 关联模板用例列表
export const getTaskDetailCaseList = data =>
  request(`/portal/v1/waf/tasks/${data.taskId}/template/${data.templateId}/caseList`, {
    params: data,
  })

// 关联模板用例的攻击类型筛选
export const getTaskDetailCaseAttackType = data =>
  request(`/portal/v1/waf/tasks/${data.taskId}/template/${data.templateId}/caseAttackList`, {
    params: data,
  })

// 获取安全设备列表
export const getSecurityDeviceList = () => request('/portal/v1/waf/task/deviceList')
